<template>
  <el-drawer title="项目联系人" :visible.sync="drawer" size='900px' :direction="direction">
    <div class="content">
      <table-content :columns='columns' :tableData="tableData" @handleEdit='handleEdit' @handleDelete='handleDelete'>
        <template #from>
          <el-form :inline="true" :size="size" @keyup.enter.native="handleQuery" @submit.native.prevent>
            <el-form-item>
              <el-button :size="size" type="primary" @click="handleQuery">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button v-if="isNeedAdd" :size="size" type="primary" @click="handleAdd">新增</el-button>
            </el-form-item>
          </el-form>
        </template>
      </table-content>
    </div>
    <add-or-update-client-contract-info ref="addOrUpdateClientContractInfo" v-if="addOrUpdateClientContractInfoVisible" @handleQuery='handleQuery'></add-or-update-client-contract-info>
  </el-drawer>
</template>

<script>
import tableContent from './tableContent.vue'
import addOrUpdateClientContractInfo from './addOrUpdateClientContractInfo.vue'
export default {
  name: "clientContactInfo",
  components: {
    tableContent,
    addOrUpdateClientContractInfo
  },
  props: {
  },
  data() {
    return {
      addOrUpdateClientContractInfoVisible: false,
      size: 'small',
      drawer: false,
      direction: "rtl",
      planInfo: {},
      row: {},
      statusObj: {},
      typeObj: {},
      timeList: [],
      tableData: [],
      isNeedAdd: true,
      columns: [
        { prop: 'clientContactPerson', label: '联系人', minWidth: 120 },
        { prop: 'clientContactPhoneNumber', label: '联系电话', minWidth: 150 },
        { prop: 'clientAddressLongitude', label: '经纬度', minWidth: 160 },
        { prop: 'clientAddress', label: '地址信息', minWidth: 120 },
        { prop: 'clientAddressDetail', label: '详细地址', minWidth: 120 },
      ]
    };
  },
  methods: {
    init(row) {
      this.drawer = true
      this.isNeedAdd = true
      this.tableData = []
      this.row = Object.assign({}, row)
      this.$nextTick(() => {
        this.handleQuery()
      })
    },
    handleQuery () {
      const projectIds = [this.row.projectId]
      this.$api.contract.getClientContactInfo(projectIds).then((res) => {
        if (res.success) {
          this.tableData = res.data
          this.isNeedAdd = this.tableData.length > 0 ? false : true
        }
      })
    },
    handleAdd () {
      this.addOrUpdateClientContractInfoVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdateClientContractInfo.init(null, this.row.projectId)
      })
    },
    handleEdit (params) {
      this.addOrUpdateClientContractInfoVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdateClientContractInfo.init(params.row, this.row.projectId)
      })
    },
    handleDelete (params) {
      const id = params.row.id
      this.$confirm('确认要删除吗？', '', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        cancelButtonClass: 'btn-custom-cancel',
        type: 'warning'
      }).then(() => {
        this.$api.contract.deleteContractProjects(id).then(res => {
          if (res.success) {
            this.$message.success("删除成功")
            this.handleQuery()
          }
        })
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  display: flex;
  overflow: auto;
  box-sizing: border-box;
  text-align: left;
  padding: 12px;
}
.order {
  height: calc(100% - 16px);
  width: 400px;
  // overflow: auto;
  margin: 0 0 16px 0;
  padding: 16px;
  box-sizing: border-box;
}

.title {
  padding: 4px 16px;
  background-color: #409eff;
  font-size: 16px;
  text-align: left;
  // border-left: 3px solid #409eff;
  color: #fff;
}

.info {
  margin: 0;
  text-align: left;
  padding: 0 16px 0 16px;
  font-size: 14px;
  color: #333;
  width: 100%;
  white-space: normal;
  word-break: break-all;
  line-height: 36px;
  box-sizing: border-box;
  // overflow: hidden;
  // text-overflow: ellipsis;
}

.time-line {
  padding: 16px 32px 0 16px;
  flex: 1;
  height: fit-content;
  overflow: auto;
  // border: 1px solid #333;
  box-sizing: border-box;
  .title {
    margin-bottom: 16px;
  }
  .info {
    margin: 0;
    line-height: 36px;
  }
}
</style>
